module.exports = __webpack_public_path__ + "img/delta-logo.767a62b2.png";